<template>
  <div>
    <PageAllow controller="DeliveryPoints" action="bind" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="districtShopsSearch"
                :label="$t('DeliveryPoint.settingKeyword', [$consts.shopName()])"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="getDistrictShopsFromAPI($route.query.stock_id)"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="districtShopsSearch = ''"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 检索条件 -->
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card class="mx-4 mb-4">
          <v-progress-linear :indeterminate="loading"></v-progress-linear>
          <v-btn text x-large color="primary" @click.stop="openAll = !openAll">
            {{ $t("openAll") }} / {{ $t("closeAll") }}
          </v-btn>
          <v-divider />
          <v-treeview
            class="py-2"
            v-model="tree"
            :items="districtShops"
            :search="districtShopsSearch"
            :filter="districtShopsFilter"
            item-key="key"
            item-children="shops"
            hoverable
            return-object
            :open.sync="districtShopsOpen"
          >
            <template v-slot:label="{ item }">
              <v-row v-if="item.district_name">
                <v-col cols="6" class="pt-6">
                  {{ item.district_name }}
                </v-col>
                <v-col cols="6" md="3">
                  <v-select
                    dense
                    :label="$t('DeliveryPoint.bindHint')"
                    style="max-width: 300px;max-height: 50px;padding-top: 10px"
                    :items="deliveryPoints"
                    item-text="name"
                    item-value="id"
                    clearable
                    v-model="item.delivery_point_id"
                    :disabled="item.bind_status"
                  />
                </v-col>
                <v-col cols="1" md="1" class="pt-6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        text-color="white"
                        @click.stop="bindDistrict(item)"
                      >
                        {{ $t("DeliveryPoint.actions.bindAll") }}
                      </v-btn>
                    </template>
                    <span>{{ $t("DeliveryPoint.actions.bindAll") }}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="1" md="1" class="pt-6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="accent"
                        text-color="white"
                        @click.stop="unBindDistrict(item)"
                      >
                        {{ $t("DeliveryPoint.actions.unBindAll") }}
                      </v-btn>
                    </template>
                    <span>{{ $t("DeliveryPoint.actions.unBindAll") }}</span>
                  </v-tooltip>
                </v-col>
<!--                <v-col cols="12">-->
<!--                  {{ item.district_name }}-->
<!--                </v-col>-->
              </v-row>
              <v-row v-else>
                <v-col cols="6" >
                  {{ $t("accountHistory.shop_name", [item.shop_code, item.shop_name]) }}
                  <v-chip
                    small
                    label
                    :color="(!item.bind_status) ? 'grey' : 'primary'"
                    text-color="white"
                  >
                    {{ (!item.bind_status) ? $t("DeliveryPoint.unBind") : $t("DeliveryPoint.isBind")}}
                  </v-chip>
                </v-col>
                <v-col cols="6" md="3">
                  <v-select
                    dense
                    :label="$t('DeliveryPoint.bindHint')"
                    style="max-width: 300px;max-height: 50px;padding-top: 10px"
                    :items="deliveryPoints"
                    item-text="name"
                    item-value="id"
                    clearable
                    v-model="item.delivery_point_id"
                    :disabled="item.bind_status"
                  />
                </v-col>
                <v-col cols="2" md="2" class="pt-6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        v-bind="attrs"
                        v-on="on"
                        :color="(!item.bind_status) ? 'primary' : 'accent'"
                        text-color="white"
                        @click.stop="bind(item)"
                      >
                        {{ (item.bind_status) ? $t("DeliveryPoint.actions.unBind") : $t("DeliveryPoint.actions.bind") }}
                      </v-btn>
                    </template>
                    <span>{{ (item.bind_status) ? $t("DeliveryPoint.actions.unBind") : $t("DeliveryPoint.actions.bind") }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </template>
          </v-treeview>
        </v-card>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import { mapState } from "vuex";
import Stocks from "@/api/stocks";
import DeliveryPoints from "@/api/delivery_points";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stocks"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.distributionCoverage"),
          disabled: true,
          href: "/stocks/distribution-coverage",
        },
        {
          text: this.stock && this.stock.name ? this.stock.name : "",
          accent: true,
          disabled: false,
        },
      ];
    },

    districtShopsFilter() {
      return (item, search) =>
        (item.district_name && item.district_name.indexOf(search) > -1) || (item.shop_name && (item.shop_name.indexOf(search) > -1 || item.shop_code.indexOf(search) > -1));
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.getDeliveryPointFromAPI()
    if (this.$route.query.stock_id) {
      Stocks.fetchOne(this.$route.query.stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock = response.data.stock
            this.getDistrictShopsFromAPI()
          }
        }.bind(this)
      );
    }
  },

  data: () => ({
    tree: [],
    districtShops: [],
    filter: "",
    openAll: false,
    districtShopsOpen: [],
    deliveryPoints: [],
    districtShopsSearch: "",
    stock: []
  }),

  methods: {
    openTree(openArr) {
      for (var i = 0; i < openArr.length; i++) {
        this.districtShopsOpen.push(openArr[i]);
        if (openArr[i].shops && openArr[i].shops.length > 0) {
          this.openTree(openArr[i].shops);
        }
      }
    },
    getDistrictShopsFromAPI() {
      if (this.stock) {
        DeliveryPoints.getDistrictShops({stock_id: this.stock.id}).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.districtShops = response.data.districts
            }
          }.bind(this)
        );
      }
    },
    getDeliveryPointFromAPI() {
      DeliveryPoints.fetchAll().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.deliveryPoints = response.data.delivery_points
          }
        }.bind(this)
      )
    },
    bind(data) {
      // 未绑定，执行绑定
      if (data.delivery_point_id == 0 || data.delivery_point_id == null) {
        this.$snackbar.error(i18n.t("DeliveryPoint.Messages.bindError"));
      }else {
        if (data.bind_status) {
          // 已绑定，执行解绑
          DeliveryPoints.unbind({
            stock_id: this.stock.id,
            delivery_point_id: data.delivery_point_id,
            shop_id: data.id,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.getDistrictShopsFromAPI()
              }
            }.bind(this)
          )
        }else {
          // 未绑定，执行绑定
          DeliveryPoints.bind({
            stock_id: this.stock.id,
            delivery_point_id: data.delivery_point_id,
            shop_id: data.id,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.getDistrictShopsFromAPI()
              }
            }.bind(this)
          )
        }
      }
    },
    bindDistrict(data){
      // 执行绑定
      if (data.delivery_point_id == 0 || data.delivery_point_id == null || !data.delivery_point_id) {
        this.$snackbar.error(i18n.t("DeliveryPoint.Messages.bindError"));
      }else {
        DeliveryPoints.bind({
          stock_id: this.stock.id,
          delivery_point_id: data.delivery_point_id,
          district_code: data.district_code,
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getDistrictShopsFromAPI()
            }
          }.bind(this)
        )
      }
    },
    unBindDistrict(data) {
      // 执行解绑
      DeliveryPoints.unbind({
        stock_id: this.stock.id,
        delivery_point_id: data.delivery_point_id,
        district_code: data.district_code,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getDistrictShopsFromAPI()
          }
        }.bind(this)
      )
    }
  },

  watch: {
    openAll: {
      handler() {
        if (this.openAll) {
          this.openTree(this.districtShops);
        } else {
          this.districtShopsOpen = [];
        }
      },
    },
  },
};
</script>